//Global Imports
import clsx from "clsx";
import React from "react";
import { Controller, useForm } from "react-hook-form";
//End Global Imports

//Local Imports
import Button from "../../../components/ui/Button";
import TextFieldNew from "../../../components/ui/TextField/TextFieldNew";
import { getErrorMessage, regexForEmailAddress } from "../../../utils";
//End Local Imports

type FormInputs = {
  email: string;
};

const StepOne = ({ registerEmail }: any) => {
  const {
    formState: { errors, isValid },
    handleSubmit,
    control,
  } = useForm<FormInputs>({ mode: "onChange" });

  return (
    <>
      <div className="flex flex-col items-start gap-1">
        <p className="xl:text-[28px] lg:text-[20px] font-semibold text-[#000]">Forgot Password?</p>
        <p className="xl:text-[20px] lg:text-[16px] font-normal text-[#000]">
          Please enter your email to reset your password
        </p>
      </div>
      <form
        onSubmit={handleSubmit(registerEmail)}
        className="flex flex-col items-start gap-5 w-full"
      >
        <div className="w-full">
          <Controller
            control={control}
            name="email"
            rules={{ required: true, pattern: regexForEmailAddress }}
            render={({ field: { name, value, onChange } }) => {
              return (
                <>
                  <p className="xl:text-xl lg:text-sm font-medium text-[#000] mt-3 mb-2">
                    Email <span className="text-red-100">*</span>
                  </p>
                  <TextFieldNew
                    name={name}
                    type="email"
                    placeholder="Enter your email"
                    inputClasses={clsx(
                      errors.email
                        ? "border-red-100"
                        : "border border-[#D9D9D9]/100 border-[0.5px]",
                      ` flex 
                    !h-[40.104px]
                    px-4  
                    justify-between 
                    items-center 
                    self-stretch 
                    rounded-[12px] 
                    bg-[#f5f5f5]/10
                    !text-[#000]
                    !pt-0
                    `
                    )}
                    placeholderStyle="text-[#9e9e9e] font-normal text-base font-inter !top-[0.45rem]"
                    value={value}
                    onChange={(v) => onChange(v)}
                    // eslint-disable-next-line
                    errorMessage={getErrorMessage(
                      errors as Record<string, { type: any }>,
                      "email",
                      "Email"
                    )}
                    error={errors.email}
                    fullWidth
                  />
                </>
              );
            }}
          />
        </div>
        <Button
          bgColor={isValid ? "bg-primary-1050" : "bg-primary-1050"}
          fontStyle={{
            fontFamily: "font-inter",
            fontSize: "text-base",
            fontWeight: "font-semibold",
            fontColor: "text-white",
          }}
          borderStyle={{
            borderWidth: "border-none",
            borderRadius: "rounded-lg",
          }}
          className="w-full h-[46px] disabled:opacity-50 disabled:cursor-not-allowed"
          disabled={!isValid}
        >
          Send OTP
        </Button>
      </form>
    </>
  );
};

export default StepOne;
